import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import BigTeaserHeadlineFont from '../../Theme/Fonts/BigTeaserHeadline'
import { TeaserProps, BasicTeaserType, TaboolaRegionItem } from '../TeaserInterface'
import BasicText from '../../Theme/Fonts/BasicText'
import LinkProps from '../../Link/LinkProps'
import TeaserInfo from '../../TeaserInfo'
import VideoLabelProps from '../../BaseComponents/Labels/Video/VideoLabelProps'
import BigTeaserImage from './Image'

export type BigTeaserProps = BasicTeaserType &
    LinkProps &
    TeaserProps &
    TaboolaRegionItem &
    VideoLabelProps & {
        /** flag to force slightly different styling */
        isTopStory?: boolean
        /** should use the full existing container height */
        expand?: boolean
        /** called when alert icon is pressed */
        onSubscribe?: () => void
        /** affects the look of the alert icon */
        subscriptionActive?: boolean
        /** first viewport elements need to have as few repaints as possible */
        webIsInFirstViewport?: boolean
    }

const BigTeaser = ({
    tag,
    headlineText,
    labels,
    onShare,
    onPress,
    href,
    published,
    mainImageUrl,
    mainImageAlt,
    type,
    videoDuration,
    isTopStory,
    testID,
    headlineNumberOfLines = 3,
    expand = false,
    webTBRegionItem,
    backgroundColor = 'pearl',
    textColor = 'onyx',
    innerRef,
    abstract,
    webRel,
    onSubscribe,
    subscriptionActive,
    teaserIcon,
    webIsInFirstViewport = false,
}: BigTeaserProps): ReactElement => {
    return (
        <Grid
            ref={innerRef}
            noExpand={!expand}
            flexShrink={0}
            flexBasis={expand ? 'auto' : undefined}
            backgroundColor={backgroundColor}
        >
            <Touchable
                onPress={onPress}
                href={href}
                testID={testID}
                webTBRegionItem={webTBRegionItem}
                expand={expand}
                flexBasis={expand ? 'auto' : undefined}
                webRel={webRel}
            >
                <>
                    <Grid horizontal noExpand marginBottom={isTopStory ? 5 : 3}>
                        <BigTeaserImage
                            labels={labels}
                            type={type}
                            imageUrl={mainImageUrl}
                            alt={mainImageAlt}
                            videoDuration={videoDuration}
                            isTopStory={isTopStory}
                            teaserIcon={teaserIcon}
                            webIsInFirstViewport={webIsInFirstViewport}
                        />
                    </Grid>
                    <Grid
                        marginX={isTopStory ? 5 : 0}
                        noExpand={!expand}
                        flexBasis={expand ? 'auto' : undefined}
                    >
                        <BigTeaserHeadlineFont
                            numberOfLines={headlineNumberOfLines}
                            className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                            color={textColor}
                        >
                            {headlineText}
                        </BigTeaserHeadlineFont>
                        {abstract ? (
                            <Grid noExpand marginTop={3}>
                                <BasicText
                                    color="keshi-3"
                                    fontSize={['FS15', 'FS15', 'FS15', 'FS18']}
                                    lineHeight="LH20"
                                    numberOfLines={7}
                                >
                                    {abstract}
                                </BasicText>
                            </Grid>
                        ) : null}
                    </Grid>
                </>
            </Touchable>
            <Grid marginX={isTopStory ? 5 : 0} noExpand marginTop={3}>
                <TeaserInfo
                    testID={`${testID}_teaserInfo`}
                    imageUrl={tag?.imageUrl}
                    alt={tag?.imageAlt}
                    name={tag?.name}
                    published={published}
                    onShare={onShare}
                    tintColor={tag?.imageTintColor}
                    onSubscribe={onSubscribe}
                    subscriptionActive={subscriptionActive}
                />
            </Grid>
        </Grid>
    )
}

export default BigTeaser
